<template>
  <v-progress-circular
    indeterminate
    :size="60"
    color="grey darken-1"
    class="ma-auto"
  />
</template>

<script>
export default {
  name: 'AppLoader',
};
</script>

<style>

</style>
